import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    edited_comment_id: null,
    comments         : [
      {
        author: {
          id     : 2,
          name   : 'Константин Константинопольский',
          avatar : '/images/avt-40-1.png',
          chevron: '/images/chevron.png',
          rank   : 'Ветеран',
        },
        id  : 1,
        date: 1542229200000,
        text: 'Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет. Для реагистрации на портале необходимо запросить логин/пароль.',
      },
    ],
    selected_number: 10,
    selected_page  : 1,
  },
  getters: {
    comments              : ({comments}) => comments,
    selected_number       : ({selected_number}) => selected_number,
    selected_page         : ({selected_page}) => selected_page,
    last_comment          : ({comments=[]}) => comments[comments.length-1],
    get_comment_by_id     : ({comments=[]}) => (id) => comments.find((comment) => comment.id == id),
    edited_comment_id     : ({edited_comment_id}) => edited_comment_id,
    current_edited_comment: ({}, {get_comment_by_id, edited_comment_id}) => get_comment_by_id(edited_comment_id),
    paginated({comments=[]}, {selected_number, selected_page}) {
      return comments.slice((selected_number*(selected_page-1)), selected_number*selected_page);
    },
  },
  mutations: {
    ADD_COMMENT(state, {comment}) {
      state.comments.push(comment);
    },
    EDIT_COMMENT_TEXT(state, obj) {
      const {id, value} = obj;
      let comment = state.comments.find((comment)=> comment.id === id);
      if (comment) {
        comment.text = value;
      }
    },
    DELETE_COMMENT(state, obj) {
      const {id, reason} = obj;
      let deleted_comment = {
        text: reason,
      };
      let commentId = state.comments.findIndex((comment)=> comment.id === id);
      if (reason) {
        state.comments = state.comments.slice(0, commentId).concat(deleted_comment, state.comments.slice(commentId+1, state.comments.length));
      } else {
        state.comments = state.comments.slice(0, commentId).concat(state.comments.slice(commentId+1, state.comments.length));
      }
    },
    SET_EDITED_ID(state, id) {
      state.edited_comment_id = id;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SET_COMMENTS(state, comments) {
      state.comments = comments;
      state.comments.forEach((x)=> x.date = x.date*1000);
    },
  },
  actions: {
    show_number({state, commit}, event) {
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: state.comments, selected: event});
    },
    add_comment({commit, getters, rootGetters, dispatch}, comment) {
      const user    = rootGetters['profile/user/user'];
      let new_comment = {
        author: {
          id     : user.id,
          name   : user.name + ' ' + user.family,
          avatar : user.avatar,
          chevron: user.chevron || '',
          rank   : user.rank || '',
        },
        message: comment.text,
      };
      dispatch('post_idea_comment', new_comment);
      commit('ADD_COMMENT', {comment: new_comment});
      commit('ideas_bank/CLOSE_MODAL', 'add_comment_modal', {root: true});
    },
    async edit_comment({commit, getters}, text) {
      const {current_edited_comment} = getters;
      let comment = current_edited_comment;
      try {
        await api.ideas_bank.edit_idea_comment(comment.id, {message: text});
        commit('EDIT_COMMENT_TEXT', {comment, value: text});
        commit('ideas_bank/CLOSE_MODAL', 'edit_comment_modal', {root: true});
      } catch (err) {
        console.error(err);
      }
    },
    async get_idea_comments({commit, rootGetters}) {
      const current_idea = rootGetters['ideas_bank/current_idea'];
      try {
        const get_idea_comments = await api.ideas_bank.get_idea_comments(current_idea);
        commit('SET_COMMENTS', get_idea_comments.data);
      } catch (err) {
        console.error(err);
      }
    },
    async post_idea_comment({commit, rootGetters, dispatch}, new_comment) {
      const current_idea = rootGetters['ideas_bank/current_idea'];
      try {
        await api.ideas_bank.post_idea_comment(current_idea, new_comment);
        commit('ideas_bank/CLOSE_MODAL', 'ideas_bank_modal', {root: true});
        dispatch('get_idea_comments');
      } catch (err) {
        console.error(err);
      }
    },
    async delete_idea_comment({commit, dispatch}, obj) {
      const {comment_id, reason} = obj;
      try {
        await api.ideas_bank.delete_idea_comment(comment_id);
        commit('DELETE_COMMENT', {id: comment_id, reason});
        commit('ideas_bank/CLOSE_MODAL', 'delete_comment_modal', {root: true});
        commit('ideas_bank/CLOSE_MODAL', 'edit_comment_modal', {root: true});
        dispatch('get_idea_comments');
      } catch (err) {
        console.error(err);
      }
    },

  },
};

